export default "__VITE_ASSET__rS35$3v9__"